import { createAsyncThunk, createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { ntxAPI } from '../../../API/axiosNeatex';
import type { CashTransferModels } from './CashTransferModels';
import type { APIResponse } from '../../Shared/shared';

export const addCashTransfer = createAsyncThunk(
  'CashTransfer/addCashTransfer',
  async (item: any, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.post('CashManagment/AddCashTransfer', item);
      return data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const updateCashTransfer = createAsyncThunk(
  'CashTransfer/updateCashTransfer',
  async (item: any, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.post('CashManagment/UpdateCashTransfer', item);
      return data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getCashTransferById = createAsyncThunk(
  'CashTransfer/getTaxManagersList',
  async (id: string, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.get(`CashManagment/GetCashTransferByI?Id=${id}`);

      return data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

// إنشاء الـ Thunk لجلب نسبة القيمة المضافة

const initialState: {
  CashTransferById: CashTransferModels;
  loading: boolean;
  error: any | null;
} = {
  CashTransferById: {} as CashTransferModels,
  loading: false,
  error: null
};

const CashTransferSlice = createSlice({
  name: 'CashTransfer',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder

      //_________________________________________
      .addCase(getCashTransferById.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getCashTransferById.fulfilled, (state, action: PayloadAction<CashTransferModels>) => {
        state.loading = false;
        state.CashTransferById = action.payload;
      })
      .addCase(getCashTransferById.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      });

    //___________________________________________________
  }
});

export default CashTransferSlice.reducer;
